import { fetcher } from '@commenda/utils';

export async function deleteRegisteredAgent(id: string, token: string) {
  const response = await fetcher(
    `registeredAgent/${id}`,
    {
      method: 'DELETE',
    },
    token
  );

  return response;
}
